(function () {
	const slideAnimations = new WeakMap();

	const slide = (element, open, onComplete) => {
		if (!element) return;
		slideAnimations.get(element)?.cancel();

		if (open) element.style.display = "block";
		const startHeight = element.getBoundingClientRect().height;
		const endHeight = open ? element.scrollHeight : 0;

		if (typeof element.animate !== "function") {
			element.style.display = open ? "block" : "none";
			onComplete?.();
			return;
		}

		element.style.overflow = "hidden";
		const animation = element.animate(
			[{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
			{ duration: 300, easing: "ease", fill: "both" },
		);
		slideAnimations.set(element, animation);
		animation.onfinish = () => {
			element.style.display = open ? "block" : "none";
			element.style.removeProperty("overflow");

			// fill: "both" holds the end height in place forever unless cancelled.
			animation.cancel();
			slideAnimations.delete(element);
			onComplete?.();
		};
	};

	const initCollapsibleContent = () => {
		document.querySelectorAll(".collapsible-content__toggle").forEach((toggle) => {
			if (toggle.dataset.sdCollapsibleBound === "true") return;
			toggle.dataset.sdCollapsibleBound = "true";
			toggle.addEventListener("click", () => {
				const parent = toggle.closest(".collapsible-content__item");
				const items = toggle.closest(".collapsible-content__items");
				const answer = toggle.nextElementSibling;
				if (!parent || !items || !answer) return;

				if (!parent.classList.contains("active")) {
					items.querySelectorAll(".collapsible-content__item.active").forEach((activeItem) => {
						if (activeItem === parent) return;
						activeItem.classList.remove("active");
						slide(activeItem.querySelector(".collapsible-content__answer"), false);
					});
					parent.classList.add("active");
					slide(answer, true);
				} else {
					parent.classList.remove("active");
					slide(answer, false);
				}
			});
		});

		document.querySelectorAll(".collapsible-content__item").forEach((item) => {
			if (item.dataset.sdCollapsibleHoverBound === "true") return;
			item.dataset.sdCollapsibleHoverBound = "true";
			const siblings = () => Array.from(item.parentElement?.children || []).filter((sibling) => sibling !== item);
			item.addEventListener("mouseenter", () => {
				item.classList.remove("collapsible-content__item--opacity");
				siblings().forEach((sibling) => sibling.classList.add("collapsible-content__item--opacity"));
			});
			item.addEventListener("mouseleave", () => {
				siblings().forEach((sibling) => sibling.classList.remove("collapsible-content__item--opacity"));
			});
		});
	};

	const openCollapsibleFromUrl = () => {
		const params = new URLSearchParams(window.location.search);
		const hash = window.location.hash;

		if (params.get("contact_posted") === "true" && hash) {
			const targetId = hash.slice(1); // "#" entfernen
			const form = document.getElementById(targetId);
			if (!form) return;

			const answer = form.closest(".collapsible-content__answer");
			if (!answer) return;

			const item = answer.closest(".collapsible-content__item");
			if (!item || item.classList.contains("active")) return;

			const items = item.closest(".collapsible-content__items");
			items?.querySelectorAll(".collapsible-content__item.active").forEach((activeItem) => {
				activeItem.classList.remove("active");
				slide(activeItem.querySelector(".collapsible-content__answer"), false);
			});
			item.classList.add("active");
			slide(answer, true, () => {
				form.scrollIntoView({ behavior: "smooth", block: "start" });
			});
		}
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
	openCollapsibleFromUrl();
})();
